export enum WebViewEvents {
  SUCCESS_AUTH = 'successAuth',
  OPEN_QR_SCANNER = 'openQRScanner',
  GOOGLE_AUTH_EVENT = 'googleAuthEvent',
  ASK_BIOMETRIC_AUTH = 'askBiometricAuth',
  ACCEPT_BIOMETRIC_AUTH = 'acceptBiometricAuth',
  SEND_BIOMETRIC_TOKEN = 'sendBiometricToken',
  CHECK_AUTO_BIOMETRIC_AUTH = 'checkAutoBiometricAuth',
  BIOMETRIC_AUTH = 'biometricAuth',
  BIOMETRIC_AUTH_FAILED = 'biometricAuthFailed',
  PULL_TO_REFRESH = 'pull-to-refresh',
  REFRESH = 'refresh',
  AUTH_ERROR = 'authError',
  LOGOUT = 'logout',
}
